<template>
  <section id="dashboard" :key="account && account.id" class="dark">
    <!-- flag demo -->
    <subscription-flag-demo v-if="isDemo && showFlagDemo" @close="showFlagDemo = false"> </subscription-flag-demo>
    <subscription-flag v-if="isPaymentEmpty && !isDemo" :show="isPaymentEmpty"> </subscription-flag>
    <subscription-flag-free v-if="!isPaymentEmpty && isFreemium && false" :show="showFlagFree" @close="showFlagFree = false"> </subscription-flag-free>
    <flag-marketing-empty v-if="!isPaymentEmpty && emptyMarketing && !isDemo" :show="showFlagMarketing" @close="showFlagMarketing = false"> </flag-marketing-empty>
    <flag-tag-empty v-if="!isPaymentEmpty && !isDemo" :show="showFlagTag" @close="closeShowFlagTag = true"> </flag-tag-empty>
    <flag-sale-empty v-if="!isPaymentEmpty && !isDemo" :show="showFlagSale" @close="closeShowFlagSale = true"> </flag-sale-empty>
    <tag-app v-if="false"></tag-app>

    <!-- modal onboarding -->
    <modal-onboarding
      v-if="showOnboarding"
      :show="true"
      menuName="Menu"
    ></modal-onboarding>

    <!-- modals versio -->
    <modal-new-version
      :show="showModalNewVersion"
      description="Nova Versão Disponivel"
      @cancel="showModalNewVersion = false"
      @accept="reloadeScreen()"
    ></modal-new-version>

    <!-- modals adblock -->
    <modal-ad-block-detect
      description="Bloqueador de anúncios detectado"
      @accept="reloadeScreen()"
    ></modal-ad-block-detect>


    <section class="sidebar" :key="refreshMenu" :class="{ expand: activeExpand, expand2:openMenu, isdemo: isDemo }">
      <div class="logo center">
        <center>
          <img class="no-mobile" src="@/assets/img/icon.png" width="60" />
          <div class="app-title no-mobile">Único Tracker</div>
          <div class="flex mobile mmiddle side-bar-logo">
            <!-- <i class="fas fa-bars"></i> -->
            <div style="position:relative" ref="menu_mobile_logo">
              <img class="logo-mobile" src="@/assets/img/icon.png" width="60" />
              <div class="app-title ">Único Tracker</div>
            </div>
          </div>
        </center>
      </div>
      <div
        class="expand-button no-mobile"
        @click="activeExpand = !activeExpand"
        >
        <div class="flex end">
          <div v-if="!activeExpand"><i class="fas fa-thumbtack"></i></div>
          <div v-else><i class="fas fa-thumbtack"></i></div>
        </div>
      </div>

      
      
      <nav class="menu">
        <ul>
          <div>
            <router-link v-if="checkResource('home') && false" :to="{ name: 'Homev2' }">
              <li
                :class="{
                  current: $route.name && $route.name === 'Homev2',
                }"
              >
                <i class="fas fa-star-of-david"></i>
                <span>Início</span>
              </li>
            </router-link>
          </div>

          <div>
            <router-link v-if="checkResource('campaigndash')" :to="{ name: 'CampaignDash', params: {slug: 'campaign'} }">
              <li
                :class="{
                  current: $route.name && $route.name === 'CampaignDash',
                }"
              >
                <i class="fas fa-route"></i>
                <span>Campanhas</span>
              </li>
            </router-link>
          </div>

          <div class="sub-menu" :class="{submenuexpand: menuSub.dash}">
            <div v-if="checkResource('profit')"  @click="menuSub.dash=!menuSub.dash">
              <li :class="{ current: $route.name === 'Dash' }">
                <i class="fas fa-flag-checkered"></i>
                <span>Dashboards</span>
                <i class="fas fa-chevron-down sub-menu-i"></i>
              </li>
            </div>
            <div class="sub-itens">
              <div v-for="(dash, k) in dashs" :key="k">
                <router-link v-if="checkResource('profit')" :to="{ name: 'Dash', params: {slug: dash.id } }">
                  <li :class="{ current: $route.name === 'Dash' && $route.params.slug === dash.id }">
                    <span>{{ dash.name }}</span>
                  </li>
                </router-link>
              </div>
              <router-link v-if="checkResource('profit')" :to="{ name: 'Dash', params: {slug: 'new-dash'} }">
                <li :class="{ current: $route.name === 'Dash' && $route.params.slug === 'new-dash' }">
                  <span>+ Criar Dashboard</span>
                </li>
              </router-link>
            </div>
          </div>

          <div class="no-mobile">
            <router-link v-if="checkResource('funnel')" :to="{ name: 'Funnel', params: { slug: 'funnel' } }">
              <li
                :class="{
                  current: $route.name && $route.name === 'Funnel',
                }"
              >
                <i class="fas fa-funnel-dollar"></i>
                <span>Funis</span>
              </li>
            </router-link>
          </div>

          <div class="sub-menu"  :class="{submenuexpand: menuSub.utm}">
            <div v-if="checkResource('profit')" @click="menuSub.utm=!menuSub.utm">
              <li :class="{ current: $route.name === 'Source' }">
                <i class="fas fa-bullseye"></i>
                <span>UTMS</span>
                <i class="fas fa-chevron-down sub-menu-i"></i>
              </li>
            </div>
            <div class="sub-itens">
              <router-link v-if="checkResource('profit')" :to="{ name: 'Source', params: {slug: 'sale'} }">
                <li :class="{ current: $route.name === 'Source' && $route.params.slug === 'sale' }">
                  <span>Vendas</span>
                </li>
              </router-link>
              <router-link v-if="checkResource('profit')" :to="{ name: 'Source', params: {slug: 'lead'} }">
                <li :class="{ current: $route.name === 'Source' && $route.params.slug === 'lead' }">
                  <span>Leads</span>
                </li>
              </router-link>
              <router-link v-if="checkResource('profit')" :to="{ name: 'Source', params: {slug: 'message'} }">
                <li :class="{ current: $route.name === 'Source' && $route.params.slug === 'message' }">
                  <span>Conversas (Whatsapp)</span>
                </li>
              </router-link>
            </div>
          </div>

          <div class="sub-menu"  :class="{submenuexpand: menuSub.jorney}" >
            <div v-if="checkResource('profit')" @click="menuSub.jorney=!menuSub.jorney">
              <li>
                <i class="fab fa-pagelines"></i>
                <span>Jornada do Cliente</span>
                <i class="fas fa-chevron-down sub-menu-i"></i>
              </li>
            </div>
            <div class="sub-itens">
              <router-link v-if="checkResource('profit')" :to="{ name: 'Jorney', params: {slug: 'sale'} }">
                <li :class="{ current: $route.name === 'Jorney' && $route.params.slug === 'sale' }">
                  <span>Vendas</span>
                </li>
              </router-link>
              <router-link v-if="checkResource('profit')" :to="{ name: 'Jorney', params: {slug: 'lead'} }">
                <li :class="{ current: $route.name === 'Jorney' && $route.params.slug === 'lead' }">
                  <span>Leads</span>
                </li>
              </router-link>
              <router-link v-if="checkResource('profit')" :to="{ name: 'Jorney', params: {slug: 'message'} }">
                <li :class="{ current: $route.name === 'Jorney' && $route.params.slug === 'message' }">
                  <span>Conversas (Whatsapp)</span>
                </li>
              </router-link>
            </div>
          </div>

          <div>
            <router-link v-if="checkResource('pages')" :to="{ name: 'Pages', params: { slug: 'pages' } }">
              <li
                :class="{
                  current: $route.name && $route.name === 'Pages',
                }"
              >
                <i class="far fa-file-word"></i>
                <span>Páginas</span>
              </li>
            </router-link>
          </div>

        



          <router-link v-if="checkResource('product')" :to="{ name: 'Product' }">
            <li
              :class="{
                current: $route.name && $route.name === 'Product',
              }"
            >
              <i class="fas fa-clipboard-list"></i>
              <span>Produtos</span>
            </li>
          </router-link>

          <router-link v-if="checkResource('insight')" :to="{ name: 'Insight' }">
            <li
              :class="{ current: $route.name && $route.name.includes('Insight') }"
              class="block-module"
            >
              <i class="fas fa-chart-area"></i>
              <span>Insights</span>
            </li>
          </router-link>


          <router-link  v-if="checkResource('additionalvalue') && false" :to="{ name: 'AdditionalValue' }" class="no-mobile">
            <li :class="{ current: $route.name === 'AdditionalValue' }">
              <i class="fas fa-balance-scale-left"></i>
              <span>Valores Adicionais</span>
            </li>
          </router-link>



          <router-link v-if="checkResource('ratestore')" :to="{ name: 'RateStore' }">
            <li
              :class="{ current: $route.name && $route.name.includes('RateStore') }"
            >
              <i class="fas fa-glasses"></i>
              <span>Avaliar Loja</span>
            </li>
          </router-link>

          <router-link v-if="checkResource('calculateproduct')" :to="{ name: 'CalculateProduct' }">
            <li
              :class="{ current: $route.name && $route.name.includes('CalculateProduct') }"
            >
              <i class="fas fa-calculator"></i>
              <span>Calculadora de Preço</span>
            </li>
          </router-link>

          <router-link v-if="checkResource('specialist')" :to="{ name: 'Specialist' }">
            <li
              :class="{ current: $route.name && $route.name.includes('Specialist') }"
              class="block-module"
            >
              <i class="fas fa-fire"></i>
              <span>O especialista</span>
            </li>
          </router-link>

          <router-link v-if="checkResource('vsl')" :to="{ name: 'VSL' }">
            <li
              :class="{ current: $route.name && $route.name.includes('VSL') }"
            >
              <i class="fas fa-video"></i>
              <span>VSL</span>
            </li>
          </router-link>

          <router-link v-if="false" :to="{ name: 'HowTo' }">
            <li :class="{ current: $route.name === 'HowTo' }">
              <i class="fas fa-info"></i>
              <span>Tutoriais</span>
            </li>
          </router-link>

          <router-link v-if="false" :to="{ name: 'Bonus' }">
            <li :class="{ current: $route.name === 'Bonus' }">
              <i class="far fa-star"></i>
              <span>Bonus</span>
            </li>
          </router-link>

          <router-link v-if="false" :to="{ name: 'Affiliate' }">
            <li :class="{ current: $route.name === 'Affiliate' }">
              <i class="fas fa-hand-holding-heart"></i>
              <span>Afiliação ÚnicoTracker (20%)</span>
            </li>
          </router-link>

          <div id="installButton" style="display: none;">
            <li>
              <i class="fab fa-sketch"></i>
              <span>Instalar App</span>
            </li>
          </div>

          <hr />
          <div class="sub-menu"  :class="{submenuexpand: menuSub.link}" >
            <div v-if="checkResource('shortlink')" @click="menuSub.link=!menuSub.link">
              <li>
                <i class="fas fa-folder-open"></i>
                <span>Links Rastreaveis</span>
                <i class="fas fa-chevron-down sub-menu-i"></i>
              </li>
            </div>
            <div class="sub-itens">
              <router-link
                v-if="checkResource('shortlink')"
                :to="{ name: 'ShortLink'}"
              >
                <li :class="{ current: $route.name === 'ShortLink' }">
                    <span>Links Encurtados</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('shortlink')"
                :to="{ name: 'ShortLinkWhats'}"
              >
                <li :class="{ current: $route.name === 'ShortLinkWhats' }">
                    <span>Links para WhatsApps</span>
                </li>
              </router-link>

            </div>
          </div>

          <div class="sub-menu" :class="{submenuexpand: menuSub.track}" >
            <div v-if="checkResource('profit')" @click="menuSub.track=!menuSub.track">
              <li>
                <i class="fas fa-folder-open"></i>
                <span>Trackeamento</span>
                <i class="fas fa-chevron-down sub-menu-i"></i>
              </li>
            </div>
            <div class="sub-itens">
              <router-link
                v-if="checkResource('trackingv2')"
                :to="{ name: 'Track', params: {slug: 'trackingv2'} }"
              >
                <li :class="{ current: $route.name === 'Track'&& $route.params.slug === 'trackingv2' }">
                  <span>Hot Tracker (Pixel)</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('custom-conversion')"
                :to="{ name: 'Track', params: { slug: 'custom-conver' } }"
              >
                <li :class="{ current: $route.name === 'Track' && $route.params.slug === 'CustomConversion' }">
                  <span>Conversões Personalizadas</span>
                </li>
              </router-link>


              <router-link
                v-if="checkResource('populatepixel')"
                :to="{ name: 'Track', params: {slug: 'populate-pixel'} }"
              >
                <li :class="{ current: $route.name === 'Track'&& $route.params.slug === 'populate-pixel' }">
                    <span>Retro Alimentação (I.A)</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('populatepixel')"
                :to="{ name: 'Track', params: {slug: 'manager-pixel'} }"
              >
                <li :class="{ current: $route.name === 'Track'&& $route.params.slug === 'manager-pixel' }">
                    <span>Tags / Pixels</span>
                </li>
              </router-link>


              <router-link
                v-if="checkResource('domain')"
                :to="{ name: 'Track', params: {slug: 'domain'} }"
              >
                <li :class="{ current: $route.name === 'Track' && $route.params.slug === 'domain' }">
                  <span>Domínios</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('tracking')"
                :to="{ name: 'Track', params: {slug: 'taxtracker'} }"
              >
                <li :class="{ current: $route.name === 'Track'&& $route.params.slug === 'taxtracker' }">
                  <span>Taxa de Tracker</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('tracking') "
                :to="{ name: 'Track', params: {slug: 'whatsapp'} }"
              >
                <li :class="{ current: $route.name === 'Track'&& $route.params.slug === 'whatsapp' }">
                  <span>WhatsApps</span>
                </li>
              </router-link>

            </div>
          </div>

          <div class="sub-menu" :class="{submenuexpand: menuSub.config}">
            <div v-if="checkResource('config')" @click="menuSub.config=!menuSub.config">
              <li>
                <i class="fas fa-folder-open"></i>
                <span>Configurações</span>
                <i class="fas fa-chevron-down sub-menu-i"></i>
              </li>
            </div>
            <div class="sub-itens">
              <router-link
                v-if="checkResource('config')"
                :to="{ name: 'Config', params: {slug: 'profile'} }"
              >
                <li :class="{ current: $route.name === 'Config'&& $route.params.slug === 'profile' }">
                  <span>Perfil</span>
                </li>
              </router-link>
              <router-link
                v-if="checkResource('config')"
                :to="{ name: 'Config', params: {slug: 'account'} }"
              >
                <li :class="{ current: $route.name === 'Config'&& $route.params.slug === 'account' }">
                  <span>Conta</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('config')"
                :to="{ name: 'Config', params: {slug: 'onboarding'} }"
              >
                <li>
                  <span>Onboarding</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('config')"
                :to="{ name: 'Config', params: {slug: 'account'} }"
              >
                <li>
                  <span>Assinatura</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('config')"
                :to="{ name: 'Config', params: {slug: 'integracoes'} }"
              >
                <li :class="{ current: $route.name === 'Config'&& $route.params.slug === 'integracoes' }">
                  <span>Integrações</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('config')"
                :to="{ name: 'Config', params: {slug: 'imports'} }"
              >
                <li :class="{ current: $route.name === 'Config'&& $route.params.slug === 'imports' }">
                  <span>Importações</span>
                </li>
              </router-link>

              <router-link  v-if="checkResource('config')" :to="{ name: 'Config', params: {slug: 'exports'} }">
                <li :class="{ current: $route.name === 'Config'&& $route.params.slug === 'exports' }">
                  <span>Exportar Dados</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('config')"
                :to="{ name: 'Config', params: {slug: 'user'} }"
              >
                <li :class="{ current: $route.name === 'Config'&& $route.params.slug === 'user' }">
                  <span>Equipe (Usuários)</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('config') && account && account.account_type === 'MANAGER'"
                :to="{ name: 'Config', params: {slug: 'project'} }"
              >
                <li :class="{ current: $route.name === 'Config'&& $route.params.slug === 'project' }">
                    <span>Projetos (Clientes)</span>
                </li>
              </router-link>
            </div>
          </div>

          <router-link v-if="false" :to="{ name: 'Canny' }">
            <li :class="{ current: $route.name === 'Canny' }">
              <i class="fas fa-bullhorn"></i>
              <span>Sugestões</span>
            </li>
          </router-link>

          <router-link v-if="hasMultipleAccounts && false" :to="{ name: 'Account' }">
            <li>
              <i class="fas fa-exchange-alt"></i>
              <span>Trocar de Projeto</span>
            </li>
          </router-link>

          <a v-if="false" @click="logout()">
            <li>
              <i class="fas fa-sign-out-alt"></i>
              <span>Sair</span>
            </li>
          </a>
        </ul>
        
      </nav>

    <div class="version flex center margin-top-l">
      <small>Versão: {{ version }}</small>
    </div>
    </section>


    <section class="main-content" :class="{ expand: activeExpand }">
      <section class="top-bar grid-flex middle between">
        <div class="main-filters flex middle flex-1">
          <breadcrumb></breadcrumb>
        </div>
        <div class="flex end no-mobile">
          <a href="https://l.lh4.me/f3xgau" target="_blank">
            <div class="">
              <b>AJUDA (HELP CENTER)</b>
            </div>
          </a>
        </div>
        <div class="flex middle">
          <div style="padding: 0px 16px; border-right: 1px solid #c2c2c2" class="flex column no-mobile">
              <div class="flex end w100">
                <div @click="changeProtect()" class="button secondary btn-download" :class="{protect: AtiveProtect}">
                  <i v-if="!AtiveProtect" class="far fa-eye"></i>
                  <i v-else class="fas fa-eye-slash"></i>
                </div>
              </div>
          </div>
          <div style="margin-right: 4px; padding: 0px 16px; border-right: 1px solid #c2c2c2" class="flex column no-mobile">
              <div class="flex end w100">
                <div @click="downloadReport('dash-profit')" class="button secondary btn-download">
                  <i class="fas fa-download"></i>
                </div>
              </div>
            </div>
          <div style="margin-right: 24px;  padding: 10px 16px; border-right: 1px solid #c2c2c2">
            <notifications></notifications>
          </div>
          <div>
            <project-selector :hasMultipleAccounts="hasMultipleAccounts"></project-selector>
          </div>
          <div>
            <profile-menu :hasMultipleAccounts="hasMultipleAccounts"></profile-menu>
          </div>
          <a v-if="false" @click="logout()" class="button secondary"
            ><i class="fa-solid fa-arrow-right-from-bracket"></i></a>
        </div>
      </section>

      <section id="report-screen" class="content-container flex w100 center column middle" :class="{ expand: activeExpand }"> 
        <div id="banner-screen" class="w100 flex center column middle txt-center">
          <a href="https://unicotracker.com.br/?utm_source=report-pdf" target="_blank">
            <h3>
              RELATÓRIO FEITO PELA unicotracker.com.br - ({{ account.id }}) {{ account.name }}
            </h3>
            <p class="margin-top-s">Criado em: {{ Date() | date }}</p>
          </a>
        </div>
        <div
          v-if="
            (!isAccountBlocked && !isAccountLimitExceeded) ||
              ((isAccountLimitExceeded || isAccountBlocked) &&
                subscriptionRoute)
          "
          class="max-1200 w100"
          :class="{'max-width': routeMaxWidth }"
        >
          <slot></slot>
          
        </div>
        
        <div v-else-if="isAccountBlocked" class="max-1200 w100">
          <blocked></blocked>
        </div>
        <div v-else-if="isAccountLimitExceeded && isFreemium" class="max-1200 w100">
          <limit-exceeded-freemium></limit-exceeded-freemium>
        </div>
        <div v-else-if="isAccountLimitExceeded" class="max-1200 w100">
          <limit-exceeded></limit-exceeded>
        </div>
        <div id="banner-screen-end" class="w100 flex center column middle txt-center">
          <a href="https://unicotracker.com.br/?utm_source=report-pdf" target="_blank">
            <h3>
              RELATÓRIO FEITO PELA unicotracker.com.br
            </h3>
            <p class="margin-top-s">Crie sua conta GRATUITA.</p>
          </a>
        </div>
      </section>
    </section>

    <div class="bottom-bar flex flex-1 middle w100">
      <div class="flex-1 txt-center" :class="{ currentRoute: $route.name === 'Dash'}">
        <router-link :to="{ name: 'Dash', params: {slug: 'first' } }">
            <i class="fas fa-flag-checkered"></i> Dash
        </router-link>
      </div>
      <div class="flex-1 txt-center"  :class="{ currentRoute: $route.name === 'CampaignDash'}">
        <router-link :to="{ name: 'CampaignDash', params: {slug: 'campaign'} }">
          <i class="fas fa-route"></i> Campanhas
        </router-link>
      </div>
      <div class="flex-1 txt-center">
        <div @click="openMenu = !openMenu">
          <i class="fas fa-bars"></i> Mais
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import ProjectSelector from "@/components/ProjectSelector";
import ProfileMenu from "@/components/ProfileMenu";
import FlagMarketingEmpty from "@/components/flag/FlagMarketingEmpty";
import FlagTagEmpty from "@/components/flag/FlagtagEmpty";
import TagApp from "@/components/tagApp/TagApp";

import SubscriptionFlag from "@/components/subscriptionFlag/SubscriptionFlag";
import SubscriptionFlagDemo from "@/components/subscriptionFlag/SubscriptionFlagDemo";
import SubscriptionFlagFree from "@/components/subscriptionFlag/SubscriptionFlagFree";
import Blocked from "@/components/blocked/Blocked";
import LimitExceeded from "@/components/blocked/LimitExceeded";
import LimitExceededFreemium from "@/components/blocked/LimitExceededFreemium";
import ModalOnboarding from "@/components/modal/ModalOnboarding.vue";
import ModalNewVersion from "@/components/modal/ModalNewVersion";
import ModalAdBlockDetect from "@/components/modal/ModalAdBlockDetect";
import Notifications from "@/components/notifications/Notifications";

import { mapState } from "vuex";

import { Account } from "@/services/account";
import { getUser, AccountsList } from "@/services/user";
import { getVersionBack } from "@/services/version";

import { getIntegrationsStatus } from "@/services/integration";

import { getDashboards } from "@/services/dashboard";


export default {
  name: "Dashboard",
  components: {
    Breadcrumb,
    ProjectSelector,
    SubscriptionFlag,
    FlagMarketingEmpty,
    FlagTagEmpty,
    TagApp,
    Blocked,
    LimitExceeded,
    ModalOnboarding,
    ModalNewVersion,
    ModalAdBlockDetect,
    SubscriptionFlagFree,
    SubscriptionFlagDemo,
    LimitExceededFreemium,
    Notifications,
    ProfileMenu
  },
  data() {
    return {
      version: "1.0.7.17",
      refreshMenu: 0,
      activeExpand: false,
      loadingDashs: false,
      openMenu: false,
      showModalNewVersion: false,
      checkVersionInterval: null,
      closeShowFlagTag: false,
      closeShowFlagSale: false,
      showFlagFree: true,
      showFlagMarketing: true,
      emptyMarketing: false,
      checkFlagFreeInterval: null,
      showFlagDemo: true,
      accounts: [],
      AtiveProtect: false,
      dashs: [],
      menuSub: {
        dash: false,
        utm: false,
        jorney: false,
        link: false,
        track: false,
        config: false,
      },
    };
  },
  updated() {
    // force only 
    if (this.dashs && this.dashs.length > 0  || this.loadingDashs) {
      return
    }
    this.getDashboards()
  },
  mounted() {
    if (!this.account.status) {
      this.getAccountInfo();
    }

    this.getDashboards()

    if (!this.user.id) {
      this.getUserInfo();
    }

    this.getAccountsList();

    this.checkVersion();
    this.checkVersionInterval = setInterval(this.checkVersion, 1000 * 1 * 60);

    if (this.isFreemium) {
      this.checkFlagFreeInterval = setInterval(this.checkFlagFree, 1000 * 1 * 5);
    }

    this.getIntegrationsStatus()

    this.checkAppInstall()

    var checkActive = localStorage.getItem("ActiveProtect");
    if (checkActive) {
      this.AtiveProtect = true
    }

    this.fixMenuMobile()
  },
  destroyed() {
    clearInterval(this.checkVersionInterval);
    clearInterval(this.checkFlagFreeInterval);

  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    isAdPixelPro() {
      const currentDomain = window.location.hostname;
      if (currentDomain.includes("adpixel.pro")) {
        return true
      }

      return false
    },
    showOnboarding() {
      // return true;
      if (!this.user || (this.user && this.user.complet_onboarding === "")) {
        return false;
      }

      return this.user && !this.user.complet_onboarding;
    },
    hasMultipleAccounts() {
      return this.accounts && this.accounts.length > 1;
    },
    isDemo() {
      let demoAccId =
      process && process.env && process.env.VUE_APP_DEMO_ACCOUNT;
      return demoAccId == this.account.id;
    },
    isPaymentEmpty() {
      return this.account && this.account.flag_payment
    },
    showFlagTag() {
      return this.account && this.account.flag_tag_no_data && !this.closeShowFlagTag
    },
    showFlagSale() {
      return this.account && this.account.flag_sale_no_data && !this.closeShowFlagSale
    },
    isFreemium() {
      return this.account && this.account.plan && this.account.plan.toLowerCase().includes('freemium')
    },
    isAccountBlocked() {
      return this.account && this.account.status === "BLOCKED";
    },
    isAccountLimitExceeded() {
      return this.account && this.account.status === "LIMIT_EXCEEDED";
    },
    subscriptionRoute() {
      if (['SubscriptionRedirect', 'Config','ConfigAccount','ConfigIntegration','ConfigIntegrationDetail'].includes(this.$route.name)) {
        return true
      }
      return false
    },
    routeMaxWidth() {
      if (['CampaignDash', 'Source'].includes(this.$route.name)) {
        return true
      }
      return false
    },
  },
  watch: {
    '$route': {
      handler() {
        this.openMenu = false
        this.refreshMenu += 1
      },
      deep: true
    },
    'account.id': {
      handler() {
        this.getDashboards()
      }
    }
  }, 
  methods: {
    getDashboards() {
      getDashboards()
        .then(result => {
          this.dashs = result.dashs
          this.loadingDashs = true
        })
    },
    changeProtect() {
      this.AtiveProtect = !this.AtiveProtect
      if (this.AtiveProtect) {
        this.$toast.success({
          title:'Sucesso',
          message:'Modo proteção de nomes ativado! Atualizando'
        })
        localStorage.setItem("ActiveProtect",this.AtiveProtect);
      } else {
        localStorage.removeItem("ActiveProtect");
        this.$toast.success({
          title:'Sucesso',
          message:'Modo proteção de nomes desativado! Atualizando'
        })
      }
      setTimeout(() => document.location.reload(true), 1000);

    },
    checkAppInstall() {
        let deferredPrompt;
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            deferredPrompt = e;
            const installButton = document.getElementById('installButton');
            installButton.style.display = 'block';

            installButton.addEventListener('click', () => {
                installButton.style.display = 'none';
                deferredPrompt.prompt();
                deferredPrompt.userChoice.then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        console.log('User accepted the install prompt');
                    } else {
                        console.log('User dismissed the install prompt');
                    }
                    deferredPrompt = null;
                });
            });
        });
    },
    downloadReport() {
      var element = document.getElementById('report-screen');
      var bannerReport = document.getElementById('banner-screen');
      var bannerReportEnd = document.getElementById('banner-screen-end');
      if (!window.html2pdf) {
        this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
          return
      }

      bannerReport.style.display ='flex'
      bannerReportEnd.style.display ='flex'

      this.$toast.success({
        title:'Sucesso',
        message:'Gerando o PDF do relatório. Aguarde'
      })

      window.html2pdf(element, {
          margin: [10, 10, 10, 50],
          filename: `report-lucreihoje-account-${this.account.id}-${this.$route.name}.pdf`,
          image: { type: 'jpg', quality: 0.98 },
          html2canvas: { dpi: 192, scale: 1, letterRendering: true },
          jsPDF: { unit: 'pt', format: 'a3', orientation: 'portrait' }
      })
      .then(() => {
        bannerReport.style.display = 'none'
        bannerReportEnd.style.display = 'none'
      })
    },
    checkFlagFree() {
      this.showFlagFree = true
    },
    getIntegrationsStatus() {
      getIntegrationsStatus()
      .then((result) => {
        let fbEmpty = false
        if (result.facebookads.status == 'DISABLE' || result.facebookads.accounts.length == 0) {
          fbEmpty = true
        }
        let gEmpty = false
        if (result.googleads.status == 'DISABLE' || result.googleads.accounts.length == 0) {
          gEmpty = true
        }

        if (fbEmpty && gEmpty) {
          this.emptyMarketing = true
        }
      })
    },
    checkVersion() {
      getVersionBack().then(resultVersion => {
        if (!resultVersion.version) {
          return;
        }
        let frontVersion = parseInt(this.version.replaceAll(".", ""), "10");

        let auxVersion = resultVersion.version.replaceAll(".", "");
        auxVersion = parseInt(auxVersion, "10");

        if (frontVersion < auxVersion) {
          this.showModalNewVersion = true;
        }
      });
    },
    reloadeScreen() {
      document.location.reload(true);
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "Login" });
    },
    checkResource(name) {
      return (
        this.account &&
        this.account.resources &&
        this.account.resources.includes(name)
      );
    },
    getAccountInfo() {
      Account().then((result) => {
        this.$store.dispatch("setAccount", result);
      });
    },
    getUserInfo() {
      getUser().then((result) => {
        this.$store.dispatch("auth", result);
      });
    },
    getAccountsList() {
      AccountsList().then((response) => {
        this.accounts = response;
      });
    },
    fixMenuMobile() {
      const menu = document.querySelector('.sidebar'); 

      if (!menu || window.innerWidth > 768) return;
      
      menu.addEventListener('mouseleave', function() {
          menu.scrollTop = 0;
      });
    }

  },
};
</script>

<style lang="scss" scoped>


.top-bar {
  .button.secondary {
    background: none;
    color: var(--primary);
    border: 0px;
    white-space: nowrap;
    padding: 12px 16px;
    font-size: 1.5rem;
    display: inline-block;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      background: var(--secondary);
      color: #fff !important;
    }
  }
}

.menu {
  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top-color: currentcolor;
    border-top-style: none;
    border-top-width: 0px;
    border-top: 1px solid #c2c2c235;
    padding: 0;
    margin: 8px 0;
  }
}

.btn-download {
  border: 1px solid var(--terciary) !important;
}

#banner-screen {
  display: none;
  padding: 24px;
  background: var(--primary);
  color: #fff;
  margin-bottom: 14px;
  a {
    color: #fff;
  }
}
#banner-screen-end {
  display: none;
  padding: 24px;
  background: var(--primary);
  color: #fff;
  margin-bottom: 14px;
  a {
    color: #fff;
  }
}

.sub-itens {
  display: none;
}

.menu {
  li:hover {
    background: var(--primary);
    color: #fff;
  }
  .sub-menu {
    .sub-itens {
      transition: all 0.9s ease; /* Define a transição para mudanças */
    }
  }
  .sub-menu.submenuexpand {
    transition: opacity 0.9s ease, transform 0.9s ease, visibility 0.9s ease;
    transform: translateX(4px);

    .sub-itens {
      display: inline-block;
      padding-left: 16px;
      li {
        // border-left: 1px solid #eee; 
        margin-left: 8px;
        border-left: 2px solid #eee;
        padding: 8px;
        border-radius: 0px !important;
        margin-top: 0px !important;
      }
    }
  }
}

.app-title {
  display: none;
}
.logo-mobile{
  width:35px;
  display: inline !important;
  position: absolute;
  top: -8px;
  left: 2px;
}
.hover-show {
  display: none !important;
}


.sidebar:not(.expand2):not(.expand) {
  &:not(:hover) {
    .sub-itens {
      display: none !important;
    }
  }
}

.bottom-bar {
  display: none;
  position: fixed;
  z-index: 20000;
  bottom: 0px;
  left: 0px;
  padding: 24px 8px;
  background: var(--boxbg);
  width: 100%;
   box-shadow: 0 -5px 5px rgba(0, 0, 0, 0.1);
  > div {
    cursor: pointer;
    color: var(--primary);
    padding-bottom: 4px;
    &.currentRoute {
      border-bottom: 1px solid var(--primary);
    }
  }

}

.protect {
  color: var(--primary) !important;
  border: 1px solid var(--primary) !important;
  i {
    color: var(--primary) !important;
  }
}
@media screen and (max-width: 1024px) {
  .bottom-bar {
    display: flex;
  }
  .sidebar:hover,.sidebar.expand,.sidebar.expand2 {
    .app-title {
      display: inherit;
      margin-top: 8px;
    }
    .fas.fa-bars {
      display: none !important;
    }
    .logo-mobile {
      display: inline-block !important;
      width:60px;
      position: relative !important;
      top: 0px;
      left: 0px;
    }
    .hover-show {
      display: block !important;
    }
  }

}
</style>
